import { useEffect } from 'react';

import { useListState, useScrollIntoView } from '@mantine/hooks';

type TransitionListState = {
  mounted: boolean;
  onTransition?: () => void;
  targetRef?: any; // Problem is the generic doesn't extend well on this. ugh
};

const defaultTransition: TransitionListState = {
  mounted: false,
  onTransition: undefined,
  targetRef: undefined,
};

// Probably one more prop away from turning it into an object
function useTransitionSections<T>(structure: T, count: number, setTargetOnScroll: boolean) {
  const { scrollIntoView, scrollableRef, targetRef } = useScrollIntoView<HTMLDivElement>({
    offset: 100,
    onScrollFinish: setTargetOnScroll ? setNextTargetRef : undefined,
  });
  const [sections, handlers] = useListState(
    Array.from({ length: count }, () => ({ ...structure, ...defaultTransition }))
  );

  /**  This auto moves the target to the next one. We may instead want to make this an optional prop */
  function setNextTargetRef() {
    const idx = sections.findIndex((section) => section.targetRef !== undefined);
    handlers.setItemProp(idx, 'targetRef', undefined);
    handlers.setItemProp(idx + 1, 'targetRef', targetRef);
  }

  /** Set target ref to desired index */
  const setTargetRef = (index: number) => {
    // Find the current target ref, set it to undefined and update the new one
    const idx = sections.findIndex((section) => section.targetRef !== undefined);
    handlers.setItemProp(idx, 'targetRef', undefined);
    handlers.setItemProp(index, 'targetRef', targetRef);
  };

  useEffect(() => {
    // Set first target index
    handlers.setItemProp(0, 'targetRef', targetRef);
  }, []);

  return {
    scrollIntoView,
    scrollableRef,
    targetRef,
    sections,
    handlers,
    setTargetRef,
    setNextTargetRef,
  };
}

export { useTransitionSections };
